import { Category } from "../../../../models/data/blobby/category.data";
import { CategoryStoreModel } from "../../../../models/store/category.store.model";

type CategoryModelV1 = Omit<CategoryStoreModel, "v" | "sc"> & {
  v: 1;
  w: number; // weight
};

export const category_v0_to_v1 = (categoryItem: Category): CategoryModelV1 => {
  return {
    dc: new Date().toString(),
    dm: new Date().toString(),
    gd: categoryItem.generalDefault,
    id: categoryItem.id,
    n: categoryItem.name,
    v: 1,
    vid: "",
    w: categoryItem.weight,
  };
};

export const category_v1_to_v2 = (category: CategoryModelV1): CategoryStoreModel => {
  delete category.w; // remove weight property
  return {
    ...category,
    sc: "manual",
    v: 2,
  };
};
